export default __webpack_public_path__ + "static/media/returntoplayer.b7fec756.jpg";